const ecommerceConfig = [
  {
    path: "/ecommerce/admin/clients",
    name: "ecommerce.admin.clients",
    component: () => import("@/modules/Ecommerce/views/ClientList.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Clientes da Loja",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/admin/payments",
    name: "ecommerce.admin.payments",
    component: () => import("@/modules/Ecommerce/views/PaymentSettings.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Configurações de Pagamento",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/admin/sellers",
    name: "ecommerce.admin.sellers",
    component: () => import("@/modules/Ecommerce/views/SellerList.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Lojistas",
      roles: [1, 5, 8],
      need_service: "external_seller",
    }
  },
  {
    path: "/ecommerce/settings",
    name: "ecommerce.settings",
    component: () => import("@/modules/Ecommerce/views/StoreSettingsPage.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Configuraçães da loja",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/admin/pages",
    name: "ecommerce.pages",
    component: () => import("@/modules/Ecommerce/views/PageList.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Páginas da Loja",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/admin/pages/:uuid/editor",
    name: "ecommerce.page-editor",
    component: () => import("@/modules/Ecommerce/views/PageEditorView.vue"),
    meta: {
      roles: [5, 1],
      layout: "full"
    }
  },
  {
    path: "/home-editor",
    name: "ecommerce.home-editor",
    component: () => import("@/modules/Ecommerce/views/HomePageEditor.vue"),
    meta: {
      roles: [5,1],
      layout: "full"
    }
  },
  {
    path: "/ecommerce/admin/footer/editor",
    name: "ecommerce.footer-editor",
    component: () => import("@/modules/Ecommerce/views/FooterEditorView.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Editor do Footer",
      roles: [1, 2, 5, 6],
      layout: "full"
    }
  },
  {
    path: '/ecommerce/store/settings',
    name: 'ecommerce.settings.store.show',
    component: () => import('@/modules/Ecommerce/views/StoreSettings.vue'),
    meta: {
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/onboarding",
    name: "ecommerce.onboarding",
    component: () => import("@/modules/Ecommerce/views/OnboardingPage.vue"),
    meta: {
      roles: [5],
      layout: "full",
      env: ["production"],
      pageTitle: "Onboarding da Loja"
    }
  },


];
export default ecommerceConfig;
